import { MaxBrainTag } from 'app/library/tag/models/tag.model';
import { Article } from './article.model';

/**
 * Transform Article model to Article Json for the API
 */
export class EditArticleCommand {
    public image: { id: number };
    public language: string;
    public title: string;
    public description: string;
    public text: string;
    public tags: MaxBrainTag[];

    constructor(tempArticle: Article) {
        if (tempArticle) {
            this.language = tempArticle.language;
            this.title = tempArticle.translations[0].title;
            this.description = tempArticle.translations[0].description;
            this.text = tempArticle.translations[0].text;
            this.image = tempArticle.image ? { id: Number(tempArticle.image.id) } : null;
            this.tags = tempArticle.tags;
        }
    }
}
